import Upsells from './Upsells';

export default Upsells;
